// The Companion module has no dedicated flag on an event:
// an event uses companions when its registration form contains a field of this type
export const COMPANION_FIELD_TYPE = 'accompagnants'

const IS_COMPANION = 'IsCompanion'

// Read-only fields appended to the users fields when the Companion module is used.
// Values come from the users API, they are not part of the registration form.
export const companionFields = [
  {
    name: IS_COMPANION,
    label: 'Accompagnant',
    field_type: 'select',
    readOnly: true,
    values: [
      { OptionValueID: 'Y', Value: 'Oui' },
      { OptionValueID: 'N', Value: 'Non' }
    ]
  },
  {
    name: 'CompanionOfEmail',
    label: 'Accompagnant de - Email',
    field_type: 'text',
    readOnly: true
  },
  {
    name: 'CompanionOfFirstName',
    label: 'Accompagnant de - Prénom',
    field_type: 'text',
    readOnly: true
  },
  {
    name: 'CompanionOfLastName',
    label: 'Accompagnant de - Nom',
    field_type: 'text',
    readOnly: true
  }
]

export const companionFieldNames = companionFields.map(field => field.name)

export function hasCompanionModule(formFields = []) {
  return formFields.some(
    field => (field.field_type || field.Type) === COMPANION_FIELD_TYPE
  )
}

export function editableFields(fields = []) {
  return fields.filter(field => !field.readOnly)
}

// API may return Yes/No, Y/N, true/false or 1/0. Unknown value stays empty.
export function normalizeIsCompanion(value) {
  if (value === undefined || value === null || value === '') return ''
  const text = `${value}`.toLowerCase()
  if (['yes', 'y', 'true', '1', 'oui'].indexOf(text) > -1) return 'Y'
  if (['no', 'n', 'false', '0', 'non'].indexOf(text) > -1) return 'N'
  return ''
}

export function formatCompanionValue(field, value) {
  return field.name === IS_COMPANION ? normalizeIsCompanion(value) : value
}

// Keep companion values of the previous user when the updated one does not carry them
export function keepCompanionValues(prevUser, nextUser) {
  const values = companionFieldNames.reduce((acc, name) => {
    const value = acc[name]
    if (prevUser.values[name] === undefined) return acc
    if (value === undefined || value === null || value === '') {
      return { ...acc, [name]: prevUser.values[name] }
    }
    return acc
  }, nextUser.values)
  return { ...nextUser, values }
}
